import PropTypes from 'prop-types';
import { RequestStatus } from '../../Constants';
export const RequestStatusPropOptional = PropTypes.oneOf(Object.keys(RequestStatus));
const RequestStatusProp = RequestStatusPropOptional.isRequired;
export default RequestStatusProp;